import React from 'react';
import { MuiBox, InputField, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from '../styled';
import { FeeInputProps } from '../types';

const FeeInput: React.FC<FeeInputProps> = ({
  label,
  amount,
  percentage,
  onAmountChange,
  onPercentageChange,
  disabled = false
}) => {
  const classes = useStyles();

  const handleDecimalChange = (value: string, onChange: (val: number | null) => void) => {
    if (value === '' || /^\d*(\.\d{0,2})?$/.test(value)) {
      onChange(value === '' ? null : (value as unknown as number));
    }
  };

  return (
    <MuiBox mt={2}>
      <Typography className={classes.formLabel}>{label}</Typography>
      <MuiBox display="flex" gap="16px" className={classes.formBox}>
        <MuiBox>
          <InputField
            align="right"
            label="Amount"
            type="text"
            value={amount ?? ''}
            disabled={disabled}
            onChange={(e) => handleDecimalChange(e.target.value, onAmountChange)}
            onBlur={(e) => {
              const value = e.target.value;
              if (value !== '') {
                onAmountChange(Number(Number(value).toFixed(2)));
              }
            }}
            sx={{
              width: { xs: '262px', sm: '175px!important' },
              height: '45px',
              '& input[type=number]': {
                MozAppearance: 'textfield'
              },
              '& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              },
              '& input[type=number]::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              }
            }}
            startIcon="$"
            size="small"
            inputProps={{ inputMode: 'decimal' }}
          />
        </MuiBox>
        <MuiBox>
          <InputField
            align="right"
            type="text"
            label="Percentage"
            value={percentage ?? ''}
            disabled={disabled}
            onChange={(e) => handleDecimalChange(e.target.value, onPercentageChange)}
            onBlur={(e) => {
              const value = e.target.value;
              if (value !== '') {
                onPercentageChange(Number(Number(value).toFixed(2)));
              }
            }}
            endIcon="%"
            size="small"
            inputProps={{ inputMode: 'decimal' }}
            sx={{
              width: { xs: '262px', sm: '175px' },
              height: '45px',
              '& input[type=number]': {
                MozAppearance: 'textfield'
              },
              '& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              },
              '& input[type=number]::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              }
            }}
          />
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};

export default FeeInput;
